export const CREATIVE_ID = 'edm-entry-conquest';
export const PARTNER_CREATIVE_ID = 'edm-entry-dealer-conquest';
export const VEHICLES_TO_SHOW = 4;
export const VEHICLES_TO_SHOW_BUTTON = 8;
export const VEHICLES_TO_SHOW_BASIC = 12;
export const VEHICLES_TO_SHOW_PARTNER = 8;
